import m from "./../../../dist/es2015/locales/lv_LV.js";
export const am5locales_lv_LV = m;